import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Dimmer, Form, Icon, Loader, Table } from 'semantic-ui-react';
import store from '../../../store';
import { formatDate, formatDateTime } from '../../../utils/shared.utils';
import './warehouse.admin.scss';

function AdminWarehouseActionsComponent(props: any) {

    const history = useHistory()

    useEffect(() => {
        var token = localStorage.getItem('adminToken')
        if (token && token !== 'undefined') {
            getActions(props.match.params.id);
        }
        else {
            console.log("Will redirect to: " + window.location.pathname)
            store.dispatch({ type: "redirectUrl", data: window.location.pathname })
            history.push("/")
        }
    }, []);

    const [productName, setProductName] = useState("");
    const [slug, setSlug] = useState("");
    const [actions, setActions] = useState([]);
    const [loading, setLoading] = useState(false);

    const tomorrow = new Date();
    const pastDate = new Date();
    tomorrow.setDate(tomorrow.getDate());
    pastDate.setDate(pastDate.getDate() - 3);
    const [startDate, setStartDate] = useState(formatDate(pastDate))
    const [endDate, setEndDate] = useState(formatDate(tomorrow))

    const getActions = (warehouseId: number) => {
        var token = localStorage.getItem('adminToken')
        if (!token || token === 'undefined') {
            console.log("Will redirect to: " + window.location.pathname)
            store.dispatch({ type: "redirectUrl", data: window.location.pathname })
            history.push("/mongol/login")
            return;
        }
        setLoading(true)
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse-actions/' + warehouseId, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ startDate: startDate + " 00:00:00", endDate: endDate + " 23:59:59"})
        }).then((res: any) => {
            setLoading(false)
            if (res.ok) {
                res.json().then((resJson: any) => {
                    if (resJson?.data?.length > 0) {
                        setProductName(resJson.data[0].name)
                        setSlug(resJson.data[0].slug)

                        resJson.data.forEach((r: any) => {
                            r.createdAtStr = formatDateTime(new Date(r.createdAt))
                            if (r.minCount === undefined || r.minCount === null) r.minCount = "-"
                            if (r.countAfter === undefined || r.countAfter === null) r.countAfter = "-"
                            if (r.minus === undefined || r.minus === null) r.minus = "-"
                            else if (Number(r.minus) === 0) r.minus = "-"
                            if (r.plus === undefined || r.plus === null) r.plus = "-"
                            else if (Number(r.plus) === 0) r.plus = "-"
                            if (r.importCost != null) {
                                r.costFormatted = parseFloat(r.importCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₮'
                            } else {
                                r.costFormatted = "-"
                            }
                            r.notesDisplay = [r.importNote, r.minusNotes].filter(Boolean).join(' | ') || '-'
                            if (r.importCountAtMinus === undefined || r.importCountAtMinus === null) r.importCountAtMinus = "-"
                        })
                    }
                    setActions(resJson.data)
                })
            }
        }).catch(err => {
            setLoading(false)
            console.error(err)
        })
    }

    const parseStatus = (status: string, createdBy: string, orderId: string) => {
        switch (status) {
          case 'confirm': return 'Захиалга #' + orderId
          case 'basket': return 'Төлөгдөөгүй #' + orderId
          case 'restock': return 'Төлөгдөөгүй #' + orderId
          case 'PROVIDER UPDATE': return `${createdBy} (provider)`
          case 'ADMIN UPDATE': return `${createdBy} (admin)`
          default: return ""
        }
    }

    return (
        <div className="page-admin">
            <Dimmer active={loading}>
                <Loader size='medium'></Loader>
            </Dimmer>

            <div className="flex-div width-100">
                <section className="admin-warehouse-form" id="my-form">
                    <div className="warehouse-actions">
                        <a onClick={() => history.goBack()}><Icon name="angle left"/>
                            <span className="underline">Буцах</span>
                        </a>
                        <div className="width-100 text-center"><h1>Үлдэгдлийн түүх</h1></div>
                        <div className="width-100"><h2>{ productName }</h2></div>
                        { slug ? <a className="underline" href={"/product/" + slug} target="_blank">Худалдааны линк</a> : null }
                        <br/>
                        <div className="report-filter">
                            <Form.Input label="Эхний өдөр: " type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}/>
                            &nbsp;&nbsp;&nbsp;
                            <Form.Input label="Сүүлийн өдөр: " type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}/>
                            &nbsp;&nbsp;&nbsp;
                            <Button onClick={() => getActions(Number(props.match.params.id))}>Дата татах</Button>
                            <br/>
                            <br/>
                        </div>

                        <Table striped className="admin-list-table" width={16}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Өөрчилсөн хэрэглэгч</Table.HeaderCell>
                                    <Table.HeaderCell>Нэмэгдсэн</Table.HeaderCell>
                                    <Table.HeaderCell>Хасагдсан</Table.HeaderCell>
                                    <Table.HeaderCell>Үлдэгдэл</Table.HeaderCell>
                                    {/* <Table.HeaderCell>Импорт үлдэгдэл</Table.HeaderCell> */}
                                    <Table.HeaderCell>Анхааруулах үлдэгдэл</Table.HeaderCell>
                                    {/* <Table.HeaderCell>Өртөг</Table.HeaderCell> */}
                                    <Table.HeaderCell>Тайлбар</Table.HeaderCell>
                                    <Table.HeaderCell>Огноо</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {actions?.map((action: any, index: number) => {
                                    return <Table.Row key={"wa-history-" + index}>
                                        <Table.Cell data-label="Өөрчилсөн хэрэглэгч">{ parseStatus(action.action, action.createdBy, action.orderId) }</Table.Cell>
                                        <Table.Cell className={action.plus !== "-" && Number(action.plus) > 0 ? "plus" : ""} data-label="Нэмэгдсэн">{ action.plus !== "-" && Number(action.plus) > 0 ? "+" : ""}{action.plus}</Table.Cell>
                                        <Table.Cell className={(action.minus !== "-" && Number(action.minus) > 0 ? "minus" : "") + (action.action === "confirm" ? " confirm" : "")} data-label="Хасагдсан">
                                            { action.minus !== "-" && Number(action.minus) > 0 ? "-" : ""}{action.minus}</Table.Cell>
                                        <Table.Cell className={action.action === "PROVIDER UPDATE" || action.action === "ADMIN UPDATE" ? "updated" : ""} data-label="Үлдэгдэл">{ action.countAfter }</Table.Cell>
                                        {/* <Table.Cell className={action.action === "PROVIDER UPDATE" || action.action === "ADMIN UPDATE" ? "updated" : ""}>{ action.importCountAtMinus }</Table.Cell> */}
                                        <Table.Cell className={action.action === "PROVIDER UPDATE" || action.action === "ADMIN UPDATE" ? "updated" : ""} data-label="Анхааруулах үлдэгдэл">{ action.minCount }</Table.Cell>
                                        {/* <Table.Cell>{ action.costFormatted ?? "-" }</Table.Cell> */}
                                        <Table.Cell data-label="Тайлбар">{ action.notesDisplay ?? "-" }</Table.Cell>
                                        <Table.Cell data-label="Огноо">{ action.createdAtStr }</Table.Cell>
                                    </Table.Row>
                                })
                                }
                            </Table.Body>
                        </Table>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default AdminWarehouseActionsComponent;